<template>
  <main-template>
    <v-row>
      <v-col>
        <span class="text-h4">Descritores</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <div class="d-flex mb-2 justify-space-between">
          <v-btn color="success" @click="criarNovo">
            <v-icon left small>mdi-plus</v-icon>
            Criar novo
          </v-btn>
          <v-text-field
            v-model="search"
            class="ml-2 search-input"
            append-icon="mdi-magnify"
            label="Pesquisar..."
            solo
            dense
            single-line
            hide-details
          />
        </div>
      </v-col>

      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="grupos"
          :loading="carregando"
          :items-per-page="10"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody v-if="items.length === 0">
              <tr>
                <td :colspan="table.headers.length" class="text-center pa-4">
                  Nenhuma configuração encontrada para o ano atual
                </td>
              </tr>
            </tbody>

            <tbody v-else is="transition-group" name="scroll-x-transition" duration="150">
              <tr v-for="grupo in items" :key="grupo.id">
                <td>{{ grupo.id }}</td>
                <td>{{ grupo.serie && grupo.serie.descricao }}</td>
                <td>{{ grupo.disciplina && grupo.disciplina.descricao }}</td>
                <td>{{ grupo.etapa && grupo.etapa.descricao }}</td>
                <td>
                  <v-btn
                    x-small
                    class="ml-1"
                    color="blue-grey lighten-3"
                    @click="editarGrupo(grupo)"
                  >
                    <v-icon small>fa fa-edit</v-icon>
                  </v-btn>
                  <v-btn
                    x-small
                    color="error"
                    class="ml-1"
                    @click="deletarGrupo(grupo)"
                    :disabled="true"
                  >
                    <v-icon small>fa fa-trash</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="carregarGrupos"
          :search="search"
        />
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
export default {
  data() {
    return {
      grupos: [],
      carregando: false,
      search: "",
      pageNumber: 0,
      paginate: {
        current_page: 0,
        last_page: 0,
      },
      table: {
        headers: [
          { text: "#", value: "id", width: "60px" },
          { text: "Série", value: "serie.descricao" },
          { text: "Disciplina", value: "disciplina.descricao" },
          { text: "Etapa", value: "etapa.descricao" },
          { text: "Ações", value: "actions", sortable: false, width: "100px" },
        ],
      },
    };
  },

  async mounted() {
    await this.carregarGrupos(0);
  },

  watch: {
    async search(val) {
      if (val.length > 2) await this.carregarGrupos(0, val);
      if (!val) await this.carregarGrupos(0);
    },
  },

  methods: {
    async carregarGrupos(pageNumber = 0, query = null) {
      this.carregando = true;
      try {
        const response = await this.$services.descritoresService.listarPaginado(pageNumber, query);
        this.paginate = response;
        this.grupos = response.data;
      } catch (e) {
        this.$handleError(e);
      } finally {
        this.carregando = false;
      }
    },

    criarNovo() {
      this.$router.push({ name: "descritores.create" });
    },

    editarGrupo(grupo) {
      this.$router.push({
        name: "descritores.edit",
        params: { grupoId: grupo.id },
      });
    },

    deletarGrupo(grupo) {
      const label = [grupo.serie?.descricao, grupo.disciplina?.descricao, grupo.etapa?.descricao]
        .filter(Boolean)
        .join(" · ");

      this.$modals.danger({
        title: "Cuidado!",
        message: `Tem certeza que deseja apagar o descritor <strong>${label}</strong>? Todos os itens cadastrados serão removidos.`,
        confirmationCode: grupo.id,
        confirmationMessage: `Digite <strong>${grupo.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => this.$modals.close(),
            props: { color: "warning", small: true },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Apagando descritor...");
              try {
                await this.$services.descritoresService.deletar(grupo.id);
                this.$toast.success("Descritor apagado com sucesso!");
                await this.carregarGrupos(this.paginate.current_page);
              } catch (e) {
                this.$handleError(e);
              }
              this.$loaderService.close();
            },
            props: { color: "error", small: true },
          },
        ],
      });
    },
  },
};
</script>
